
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthFormProvider } from "@/context/auth-form";
import AuthCard from "@/components/auth/AuthCard";
import ResetPasswordForm from "@/components/auth/ResetPasswordForm";
import { supabase } from "@/integrations/supabase/client";

const PasswordResetPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isValidating, setIsValidating] = useState(true);
  
  useEffect(() => {
    const validateSession = async () => {
      setIsValidating(true);
      
      try {
        // Check if we have a valid session
        const { data, error } = await supabase.auth.getSession();
        
        if (error || !data.session) {
          console.error("No valid session for password reset:", error);
          // Removed toast notification - we'll redirect to the expired page instead
          
          // Mark as expired in session storage
          sessionStorage.setItem('token_expired', 'true');
          
          // Redirect to forgot password page
          navigate("/auth?mode=forgotPassword&token_expired=true", { replace: true });
          return;
        }
        
        console.log("Valid session for password reset detected");
        setIsValidating(false);
      } catch (err) {
        console.error("Error validating session:", err);
        // Mark as expired in session storage
        sessionStorage.setItem('token_expired', 'true');
        
        // Redirect to forgot password page
        navigate("/auth?mode=forgotPassword&token_expired=true", { replace: true });
      }
    };
    
    validateSession();
  }, [navigate]);
  
  if (isValidating) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center px-4 py-12 bg-gradient-to-b from-mono-charcoal to-mono-eerieBlack">
        <div className="animate-pulse flex flex-col items-center">
          <div className="h-16 w-16 bg-mono-slateGray/20 rounded-full"></div>
          <div className="mt-6 h-5 w-52 bg-mono-slateGray/20 rounded"></div>
          <div className="mt-3 h-4 w-40 bg-mono-slateGray/20 rounded"></div>
        </div>
      </div>
    );
  }
  
  return (
    <AuthFormProvider>
      <div className="flex min-h-screen flex-col items-center justify-center px-4 py-12 bg-gradient-to-b from-mono-charcoal to-mono-eerieBlack">
        <AuthCard>
          <ResetPasswordForm />
        </AuthCard>
      </div>
    </AuthFormProvider>
  );
};

export default PasswordResetPage;
